import useMoney from '../../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../../lang/LangEnum';
import {
  OrderProductError,
  OrderProductRuleExtraDetails,
} from '../../../../../../../services/modules/order-product/order-product.types';
import { useTranslation } from '../../../../../../translation/TranslationContext';

const useOrderProductImageAndLabelTooltip = (productErrors: OrderProductError[]) => {
  const { translate } = useTranslation();
  const { getCurrencySymbol } = useMoney();

  const getPackNamesWithNumberOfSharedProducts = (extra?: OrderProductRuleExtraDetails) =>
    extra?.packsWithError
      ?.map((pack) => {
        if (!pack.orderProductsUsingSamePackStock?.length) {
          return pack.name;
        }

        return `${pack.name} (${translate(
          LangEnum.ORDER_PRODUCT_RULE_INVALID_PACK_STOCK_SHARED_PACK_STOCK,
          { quantity: pack.orderProductsUsingSamePackStock.length },
        )})`;
      })
      .join(', ');

  const registrationErrors = productErrors.map(({ messageCode, extra }) =>
    translate(messageCode, {
      messageByItem: true,
      currency: getCurrencySymbol(),
      minimumQuantity: extra?.minimumQuantity,
      achievedQuantity: extra?.achievedQuantity,
      packsWithErrorQuantity: extra?.packsWithError?.length,
      packNames: extra?.packsWithError?.map((pack) => pack.name).join(', '),
      packNamesWithNumberOfSharedProducts: getPackNamesWithNumberOfSharedProducts(extra),
      kitName: extra?.kitWithError?.name,
    }),
  );

  return { registrationErrors };
};

export default useOrderProductImageAndLabelTooltip;
